// extracted by mini-css-extract-plugin
export default {"departments":"OH-z","departmentHeading":"PH-z","departmentSection":"QH-z","departmentName":"RH-z","departmentLink":"SH-z","expandIcon":"TH-z"};